
/**
 * AR Collection Queue - Filter State
 */
import { PaginatedResponse, GroupByOption, CollectionSortByOption, ApiResponse, ExportType } from '@repo/types';
import { QueryStringParams } from '@xtnd/web/shared';
import { Matter } from './matter';

export type GROUP_BY = GroupByOption.NONE | GroupByOption.CLIENT | GroupByOption.ORIGINATING | GroupByOption.RESPONSIBLE;
export type SORT_BY = `${CollectionSortByOption}`;
export type ArCollectionQueueResponse = PaginatedResponse<CollectionItem>;
export type ArMattersResponse = ApiResponse<Matter[]>;
export type GroupBySelectOption = {
  label: string;
  value: GROUP_BY
}

export const GroupByOptions: GroupBySelectOption[] = [
  { label: 'No Grouping', value: GroupByOption.NONE },
  { label: 'Group by Client', value: GroupByOption.CLIENT },
  { label: 'Group by Originating Attorney', value: GroupByOption.ORIGINATING },
  { label: 'Group by Responsible Attorney', value: GroupByOption.RESPONSIBLE },
];

export const DaysPastDueOptions = [
  { label: 'Current', value: '0' },
  { label: 'All Past Due', value: '1' },
  { label: '30+ days', value: '30' },
  { label: '60+ days', value: '60' },
  { label: '90+ days', value: '90' },
  { label: '120+ days', value: '120' },
];

export interface ArCollectionQueueFilter {
  groupBy: GROUP_BY;
  daysPastDue: number;
  search?: string;
  entityId?: string;
  clientId?: string;
  matterGroupBy?: GroupByOption;
  exportType?: ExportType;
  exportFilename?: string;
  exportMeta?: { title?: string; headers?: string[][] };
  childSearch?: string;
  grandChildSearch?: string;
}
export interface ArCollectionQueueParams extends QueryStringParams {
  filters?: ArCollectionQueueFilter;
  sorts?: Record<SORT_BY, 'asc' | 'desc'>
}

export interface CollectionItem {
  clientId?: string;
  clientName?: string;
  matterId: string;
  matterDescription: string;
  matterDisplayNumber: string;
  matterNumber?: string;
  originatingAttorneyId?: string;
  originatingAttorneyName?: string;
  responsibleAttorneyId?: string;
  responsibleAttorneyName?: string;
  outstandingFees?: number;
  outstandingExpenses?: number;
  totalOutstanding: number;
  maxDaysPastDue: number;
  numOfMatters?: number;
  numOfInvoices?: number;
  isSplitInvoice?: number;
}
